var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolifoniaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 584.6 143.1",
    style: {
      enableBackground: "new 0 0 584.6 143.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#000000;stroke-width:0.75;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.7,31.6h-32.5v83.8h14V82.2h18c17.7,0,28.9-9.8,28.9-25.6C177.9,41.4,166.9,31.6,149.7,31.6z M131.2,43.4 h17.5c9.6,0,15,4.9,15,13.5c0,8.8-5.3,13.5-15.4,13.5h-17.1V43.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.4,52.8c-8,0-14,2.8-17.9,8.5c-0.1-2.3-0.3-5.2-0.4-6.3l-0.1-0.8h-13v0.9c0.1,4.7,0.1,10,0.1,15.2v45.9 h13.5v-33c0-8.5,2.5-18.7,14.1-18.7c7.6,0,11.3,4.4,11.3,13.6v38.1h13.3V76.7C477.3,61.8,469.5,52.8,456.4,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.3,52.4L214.3,52.4c-17.6,0-32,14.2-32,32c0,17.6,14.2,32,32,32l0,0l0,0c17.6,0,32-14.4,32-32 S231.9,52.4,214.3,52.4z M214.3,103.6c-10.6,0-19.2-8.5-19.2-19.2s8.5-19.2,19.2-19.2s19.2,8.5,19.2,19.2 C233.5,94.9,224.8,103.6,214.3,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.9,52.4L380.9,52.4c-17.6,0-32,14.2-32,32s14.2,32,32,32l0,0l0,0c17.6,0,32-14.4,32-32 S398.7,52.4,380.9,52.4z M380.9,103.6c-10.6,0-19.2-8.5-19.2-19.2s8.5-19.2,19.2-19.2c10.6,0,19.2,8.5,19.2,19.2 S391.5,103.6,380.9,103.6L380.9,103.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.1,114.2c-0.5-4.4-0.9-8.9-0.8-13.3V72.8c0-13.7-8.2-20.7-24.1-20.7h-0.1c-19.7,0-23.8,11.8-24.5,18.9 l-0.1,0.9h12.8l0.1-0.6c1-4.7,2.6-8.5,11.3-8.5c10.2,0,11.4,5.8,11.4,10.2v4H546c-19.2,0-29.3,7.1-29.3,20.6 c-0.1,4.9,1.7,9.7,5.1,13.2c3.8,4,9.3,6.1,16.2,6.1c8,0,13.9-2.3,17.5-7.1c0.1,1.7,0.4,3.4,0.8,5.1l0.3,0.5h12.8L569.1,114.2z  M540.6,106.1c-6.3,0-10.2-3.6-10.2-9.3c0-7.1,5.2-10.4,16.6-10.4h8.3v1C555.3,98.6,552.8,106.1,540.6,106.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.1,
    y: 27.4,
    className: "st0",
    width: 13.3,
    height: 88.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M345.7,27.1c-2.3-0.5-4.8-0.8-7.1-0.8c-12,0-18.8,7.8-18.8,21.8v6h-9.5v11h9.5V116h13.3V65h11.8V54h-11.8v-5.2 c0-6.9,1.2-10.8,7.3-10.8c1.6,0,3.1,0.1,4.7,0.5l1,0.3V27.4L345.7,27.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.7,
    y: 54,
    className: "st0",
    width: 13.3,
    height: 61.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.7,
    y: 29.3,
    className: "st0",
    width: 13.3,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 54,
    className: "st0",
    width: 13.3,
    height: 61.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 29.3,
    className: "st0",
    width: 13.3,
    height: 13.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.2,83.3v-2.6c5.1,0,9.2-4.1,9.2-9.2s-4.1-9.2-9.2-9.2v-2.6c6.5,0,11.7,5.2,11.7,11.7S21.7,83.3,15.2,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1,71.6c0-13.2-5.2-25.9-14.3-35.4c0.6-0.6,1.2-1.2,1.8-1.8c9.7,10,15.1,23.4,15.1,37.2c0,6.5-1.2,13-3.5,19.1 c-0.7-0.8-1.2-1.6-1.8-2.5C65.1,82.9,66.1,77.3,66.1,71.6z M62.1,91.1c-7.9,19-26.4,31.3-46.9,31.4v2.6c21.1,0,40.2-12.4,48.8-31.7 C63.4,92.6,62.7,91.9,62.1,91.1z M51.7,32.6c-9.9-9.3-22.9-14.5-36.5-14.5v2.6c12.9,0,25.3,4.9,34.6,13.7 C50.5,33.9,51.1,33.2,51.7,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,41.6V39c17.9,0,32.5,14.6,32.5,32.5c0,7.1-2.3,13.9-6.5,19.6c-0.4-1-0.8-1.9-1.1-2.9c3.3-5,5.1-10.7,5.1-16.6 C45.2,55,31.8,41.6,15.2,41.6z M38.4,90.7c-5.7,6.9-14.2,10.9-23.2,10.9v2.6c9.3,0,18-3.9,24.2-10.8C39.1,92.4,38.7,91.6,38.4,90.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2,83.3c-6.5,0.2-11.8-5-12-11.5s5-11.8,11.5-12c0.2,0,0.4,0,0.6,0v2.7c-5.1,0-9.2,4.1-9.2,9.2s4.1,9.2,9.2,9.2l0,0 L88.2,83.3L88.2,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8,108.8C35.4,93.9,30.8,72,38.3,52.5c0.7,0.8,1.2,1.6,1.8,2.5c-6.3,18.1-1.8,38.3,11.5,52 C51.1,107.6,50.5,108.2,49.8,108.8z M51.7,110.6c9.9,9.3,22.9,14.5,36.5,14.5v-2.6c-12.9,0-25.3-4.9-34.6-13.7 C53,109.3,52.3,110,51.7,110.6z M39.4,49.8c0.7,0.8,1.2,1.5,1.8,2.2c7.9-19,26.4-31.4,46.9-31.4V18C67.1,18.2,48,30.6,39.4,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2,101.6v2.6c-17.9,0-32.5-14.6-32.5-32.5c0-7.1,2.3-13.9,6.5-19.6c0.4,1,0.8,1.9,1.1,2.9c-9.2,13.7-5.4,32.3,8.3,41.6 C76.5,99.9,82.3,101.6,88.2,101.6z M64,49.8c0.4,0.9,0.8,1.7,1.1,2.7c5.7-6.9,14.2-10.9,23.2-10.9V39C79,39,70.2,42.9,64,49.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.2,364.3H-0.9V429H9.9v-25.6h13.9c13.7,0,22.3-7.6,22.3-19.8C46,371.9,37.5,364.3,24.2,364.3z M9.9,373.4h13.5 c7.4,0,11.6,3.8,11.6,10.4c0,6.8-4.1,10.4-11.9,10.4H9.9V373.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,380.7c-6.2,0-10.8,2.2-13.8,6.6c-0.1-1.8-0.2-4-0.3-4.9l-0.1-0.6h-10v0.7c0.1,3.6,0.1,7.7,0.1,11.7v35.4h10.4v-25.5 c0-6.6,1.9-14.4,10.9-14.4c5.9,0,8.7,3.4,8.7,10.5v29.4h10.3v-30.5C277.1,387.6,271.1,380.7,261,380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1,380.4L74.1,380.4c-13.6,0-24.7,11-24.7,24.7c0,13.6,11,24.7,24.7,24.7l0,0l0,0c13.6,0,24.7-11.1,24.7-24.7 S87.7,380.4,74.1,380.4z M74.1,419.9c-8.2,0-14.8-6.6-14.8-14.8c0-8.2,6.6-14.8,14.8-14.8s14.8,6.6,14.8,14.8 C88.9,413.2,82.2,419.9,74.1,419.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.7,380.4L202.7,380.4c-13.6,0-24.7,11-24.7,24.7s11,24.7,24.7,24.7l0,0l0,0c13.6,0,24.7-11.1,24.7-24.7 S216.4,380.4,202.7,380.4z M202.7,419.9c-8.2,0-14.8-6.6-14.8-14.8c0-8.2,6.6-14.8,14.8-14.8s14.8,6.6,14.8,14.8 S210.9,419.9,202.7,419.9L202.7,419.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,428.1c-0.4-3.4-0.7-6.9-0.6-10.3v-21.7c0-10.6-6.3-16-18.6-16h-0.1c-15.2,0-18.4,9.1-18.9,14.6l-0.1,0.7h9.9l0.1-0.5 c0.8-3.6,2-6.6,8.7-6.6c7.9,0,8.8,4.5,8.8,7.9v3.1h-7c-14.8,0-22.6,5.5-22.6,15.9c-0.1,3.8,1.3,7.5,3.9,10.2 c2.9,3.1,7.2,4.7,12.5,4.7c6.2,0,10.7-1.8,13.5-5.5c0.1,1.3,0.3,2.6,0.6,3.9l0.2,0.4h9.9L348,428.1z M326,421.8 c-4.9,0-7.9-2.8-7.9-7.2c0-5.5,4-8,12.8-8h6.4v0.8C337.3,416,335.4,421.8,326,421.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 361.1,
    width: 10.3,
    height: 68.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,360.8c-1.8-0.4-3.7-0.6-5.5-0.6c-9.3,0-14.5,6-14.5,16.8v4.6h-7.3v8.5h7.3v39.3h10.3v-39.3h9.1v-8.5h-9.1v-4 c0-5.3,0.9-8.3,5.6-8.3c1.2,0,2.4,0.1,3.6,0.4l0.8,0.2v-8.8L175.5,360.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 381.6,
    width: 10.3,
    height: 47.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 362.5,
    width: 10.3,
    height: 10.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.9,
    y: 381.6,
    width: 10.3,
    height: 47.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.9,
    y: 362.5,
    width: 10.3,
    height: 10.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.2,405.3v-2.2c4.4,0,8-3.6,8-8s-3.6-8-8-8v-2.2c5.7,0,10.2,4.6,10.2,10.2S383.9,405.3,378.2,405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.6,395.1c0-11.5-4.5-22.6-12.5-30.9c0.5-0.5,1.1-1.1,1.6-1.6c8.5,8.7,13.2,20.4,13.2,32.5 c0,5.7-1.1,11.3-3.1,16.7c-0.6-0.7-1.1-1.4-1.6-2.2C421.8,405,422.6,400.1,422.6,395.1z M419.2,412.2c-6.9,16.6-23.1,27.3-41,27.4 v2.2c18.4,0,35.1-10.8,42.6-27.6C420.3,413.5,419.7,412.8,419.2,412.2z M410.1,361.1c-8.7-8.1-20-12.7-31.9-12.7v2.2 c11.2,0,22.1,4.2,30.2,12C409,362.2,409.5,361.6,410.1,361.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.2,369v-2.2c15.7,0,28.4,12.7,28.4,28.4c0,6.2-2,12.2-5.7,17.1c-0.3-0.8-0.7-1.7-1-2.5 c2.9-4.3,4.4-9.3,4.4-14.5C404.4,380.7,392.7,369,378.2,369z M398.4,411.8c-5,6-12.4,9.5-20.2,9.5v2.2c8.1,0,15.7-3.4,21.2-9.4 C399,413.3,398.7,412.6,398.4,411.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.9,405.3c-5.7,0.2-10.3-4.3-10.5-10s4.3-10.3,10-10.5c0.2,0,0.3,0,0.5,0v2.3c-4.4,0-8,3.6-8,8s3.6,8,8,8 l0,0V405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.4,427.6c-12.6-13-16.6-32.1-10.1-49.1c0.6,0.7,1.1,1.4,1.6,2.2c-5.5,15.8-1.6,33.4,10.1,45.4 C409.5,426.6,409,427.1,408.4,427.6z M410.1,429.2c8.7,8.1,20,12.7,31.9,12.7v-2.2c-11.2,0-22.1-4.2-30.2-12 C411.2,428.1,410.6,428.7,410.1,429.2z M399.4,376.1c0.6,0.7,1.1,1.3,1.6,1.9c6.9-16.6,23.1-27.4,41-27.4v-2.2 C423.5,348.5,406.9,359.4,399.4,376.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.9,421.3v2.2c-15.7,0-28.4-12.7-28.4-28.4c0-6.2,2-12.2,5.7-17.1c0.3,0.8,0.7,1.7,1,2.5 c-8,12-4.7,28.2,7.2,36.3C431.7,419.8,436.8,421.3,441.9,421.3z M420.8,376.1c0.3,0.7,0.7,1.5,1,2.3c5-6,12.4-9.5,20.2-9.5v-2.2 C433.9,366.7,426.2,370.1,420.8,376.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolifoniaLogo);
export default __webpack_public_path__ + "static/media/PolifoniaLogo.2f709ff12327e2c7497d86f7dade6f86.svg";
export { ForwardRef as ReactComponent };